import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Config } from '../../models/config.interface';
import { Feature } from '../../models/feature.type';
import { CONFIG } from '../../tokens/config.token';

@Injectable({ providedIn: 'root' })
export class FeatureEnabledGuard<T extends Config = Config> {
  private readonly config = inject(CONFIG);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const feature: Feature<T> | undefined = route.data?.['feature'];

    if (!feature) {
      this.redirectTo(route);
      return false;
    }

    const featureEnabled = Boolean(
      this.config.domainFeatures?.[
        feature as keyof typeof this.config.domainFeatures
      ],
    );

    if (featureEnabled) {
      return true;
    }

    this.redirectTo(route);
    return false;
  }

  private redirectTo(route: ActivatedRouteSnapshot): void {
    const redirectTo: string = route.data?.['redirectTo'] ?? '/';
    this.router.navigate([redirectTo], {
      queryParams: route.queryParams,
      replaceUrl: true,
    });
  }
}
